import { render, staticRenderFns } from "./dataBaseFormTable.vue?vue&type=template&id=206346a7&scoped=true&"
import script from "./dataBaseFormTable.vue?vue&type=script&lang=js&"
export * from "./dataBaseFormTable.vue?vue&type=script&lang=js&"
import style0 from "./dataBaseFormTable.vue?vue&type=style&index=0&id=206346a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206346a7",
  null
  
)

export default component.exports